import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function analyzeCase(payload) {
  const { data } = await axios.post(`${API}/gemini/analyze-case`, payload);
  return data;
}

export async function suggestPontics(payload) {
  const { data } = await axios.post(`${API}/gemini/suggest-pontics`, payload);
  return data;
}

export async function validateBridge(payload) {
  const { data } = await axios.post(`${API}/gemini/validate-bridge`, payload);
  return data;
}

export async function budgetAdvisor(payload) {
  const { data } = await axios.post(`${API}/gemini/budget-advisor`, payload);
  return data;
}

export async function translateText(text, targetLanguage) {
  const { data } = await axios.post(`${API}/gemini/translate`, {
    text,
    target_language: targetLanguage,
  });
  return data;
}

export async function translateComment(text) {
  const { data } = await axios.post(`${API}/gemini/translate-comment`, { text });
  return data;
}

export async function moderateComment(text) {
  const { data } = await axios.post(`${API}/moderate-comment`, { text });
  return data;
}
